import { Link } from 'react-router-dom'

/**
 * 強制 migrate 完了画面。
 *
 * /auth/signup が `migrated: true` を返したあとにフロントが遷移する。
 */
export function OnboardingMigratedPage() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="max-w-md text-center space-y-4">
        <h1 className="text-2xl font-bold">無料プランへの登録が完了しました</h1>
        <p className="text-sm text-muted-foreground">
          お試し中に作ったプロジェクト・ファイル・共有URLは、すべてそのまま引き継がれました。
          共有URLは同じURLのまま継続して使えます。
        </p>
        <Link
          to="/projects"
          className="inline-block px-6 py-3 bg-primary text-primary-foreground rounded-md font-medium"
        >
          プロジェクトを開く
        </Link>
      </div>
    </div>
  )
}
